/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  contain: content;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  height: calc(28rem /14);
}

:host(:focus) {
  outline: none;
}

.container {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  height: calc(28rem /14);
  width: calc(70rem /14);
  border-radius: 1rem;
}

.knob {
  display: block;
  position: absolute;
  top: calc(3rem /14);
  height: calc(22rem /14);
  width: calc(22rem /14);
  border-radius: 50%;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-text-on-secondary, #FFFFFF);
}

.icon {
  position: absolute;
  top: calc(-1rem /14);
  opacity: 1;
}
.icon > davinci-icon {
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-secondary, #FFFFFF);
}
.icon.grey > davinci-icon {
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-secondary-light, #FFFFFF);
}
.icon.darkgrey > davinci-icon {
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-secondary-dark, #FFFFFF);
}

.container,
.knob,
.icon {
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
}

:host(:not([checked])) .container {
  background-color: #50585C;
  background-color: var(--davinci-color-secondary-dark, #50585C);
}
:host(:not([checked])) .container:hover {
  background-color: #737F85;
  background-color: var(--davinci-color-secondary, #737F85);
}
:host(:not([checked])) .knob {
  left: calc(4rem /14);
}
:host(:not([checked])) .icon {
  left: calc(32rem /14);
}
:host(:not([checked])) .iconOn {
  opacity: 0;
}

:host([checked]) .container {
  background-color: #007CC1;
  background-color: var(--davinci-color-primary, #007CC1);
}
:host([checked]) .container:hover {
  background-color: #009DF4;
  background-color: var(--davinci-color-primary-light, #009DF4);
}
:host([checked]) .knob {
  left: calc(44rem /14);
}
:host([checked]) .icon {
  left: calc(-34rem /14);
}
:host([checked]) .iconOff {
  opacity: 0;
}

:host([disabled]) {
  pointer-events: none;
  cursor: default;
}
:host([disabled]) .container {
  background-color: #C5CACC;
  background-color: var(--davinci-color-outline-light, #C5CACC);
}
:host([disabled]) .icon > davinci-icon {
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}
:host([disabled]) .icon > davinic-icon-ref {
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}

:host([hidden]) {
  display: none;
}`;
export { style };
